// externals
import type { FC, KeyboardEvent } from 'react';

// libraries
import { PriceInput } from '@makemydeal/dr-shared-components/price-input';
import { featureToggleSelectors } from '@makemydeal/dr-shared-store';

// interfaces/types
import type { ColumnMapping, InputChangeInterstateEventHandler } from './../manualAccessoriesTypes';
import type { Accessory } from '@makemydeal/dr-dash-types';

// consts/enums
import * as deskingConstants from '../../../constants';
import { getLabelWithRequiredHint } from '../manualAccessoriesUtils';

export type ManualAccessorySaleFieldStateProps = {
    disabled: boolean;
    index: number;
    amount: string;
    saleColumnMapping: ColumnMapping<number>;
    weOwe: boolean;
    accessories?: Accessory[];
    hasError?: boolean;
    errorMessage?: string;
};

export type ManualAccessorySaleFieldDispatchProps = {
    handleInputChange: InputChangeInterstateEventHandler;
    handleOnBlur: (fieldName: string) => void;
    handleKeyPress: (event: KeyboardEvent<HTMLInputElement | HTMLTextAreaElement | HTMLDivElement>, fieldName: string) => void;
    shouldTriggerValidation?: boolean;
    isOptionalDeskingMode?: boolean;
};

export type ManualAccessorySaleFieldProps = ManualAccessorySaleFieldDispatchProps & ManualAccessorySaleFieldStateProps;

export const ManualAccessorySaleField: FC<ManualAccessorySaleFieldProps> = ({
    disabled,
    index,
    amount,
    saleColumnMapping: { fieldName },
    weOwe,
    handleInputChange,
    handleOnBlur,
    handleKeyPress,
    hasError,
    errorMessage,
    isOptionalDeskingMode = false
}) => {
    return (
        <PriceInput
            sx={{ minWidth: '108px' }}
            size="sm"
            allowDecimal={true}
            displayLabel={true}
            className={'base-accessories-label'}
            data-testid={`${fieldName}-${index}`}
            label={getLabelWithRequiredHint('Price', isOptionalDeskingMode)}
            name={`${fieldName}-${index}`}
            onChange={(e) => {
                handleInputChange(e, fieldName);
            }}
            onBlur={() => {
                handleOnBlur(fieldName);
            }}
            hasError={hasError}
            errorMessage={errorMessage}
            onKeyDown={(e) => {
                handleKeyPress(e, fieldName);
            }}
            required={!weOwe && !isOptionalDeskingMode}
            value={amount}
            disabled={disabled}
            customErrorMessages={{
                isRequired: deskingConstants.REQUIRED
            }}
            selectOnFocusSelector={featureToggleSelectors.isAutoSelectContentOnSlideOutsEnabledAfterBootstrap}
        />
    );
};
